<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  📰 {{'newsMatchesInterests' | translate}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12 mb-3 mb-xl-0" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
              <!-- Card -->
              <div class="card mb-4">
                <!-- Card body -->
                <div class="card-body" style="height: 200px;">
                  <div class="skeleton-card"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  📰 {{'newsMatchesInterests' | translate}}
                </h1>
                <div class="d-flex flex-wrap">
                  <span *ngFor="let interest of interests" class="badge bg-primary me-2 mb-2">
                    {{ interest }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container mb-8">
          <app-no-content-found *ngIf="notifications.length==0">
          </app-no-content-found>
          <div class="row "  *ngIf="notifications.length>0">
            <div class="col-lg-12 mb-3" *ngFor="let item of notifications" >
            <div class="card p-4" (click)="ShowDialog(item)">
              <img src="../../../assets/images/download.png" class="news-image" style="height: 30px; width: 30px;" alt="News Image">
              <h5 class="news-title text-dark mt-3">{{item.title}}</h5>
              <div class="news-description text-dark" [innerHTML]="sanitizeHtmlWithImageFix(item.message).sanitizedHtml"></div>

              <img *ngIf="sanitizeHtmlWithImageFix(item.message).imageSrc" 
                  [src]="sanitizeHtmlWithImageFix(item.message).imageSrc" 
                  class="img-fluid rounded-2 shadow-sm my-3"
                  style="max-width: 100%; height: auto; object-fit: cover;" />
              
              <div class="news-footer text-dark">
                <span>{{ item.timestamp | date:'dd-MM-yy hh:mm a' }}</span>
                  <button (click)="ShowDialog(item)"  class="btn btn-primary">{{'ReadMore' | translate}} →</button>
              </div>
          </div>
    
            </div>
            <div class="col-lg-12 mb-8">
              <div class="pagination-controls text-center">
                <button class="btn btn-secondary" (click)="goToPrev(userId)" [disabled]="!canGoPrev">Previous</button>
                <button class="btn btn-primary ms-3" (click)="goToNext(userId)" [disabled]="!canGoNext">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </section>
</main>

<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>

<p-dialog header="Detail" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <div *ngIf="SingleNotification!=null">
    <h2>
      {{SingleNotification.title}}
    </h2>
    <div  *ngIf="SingleNotification!=null">
      <div class="news-description text-dark" [innerHTML]="sanitizeHtmlWithImageFix(SingleNotification.message).sanitizedHtml"></div>
  
                <img *ngIf="sanitizeHtmlWithImageFix(SingleNotification.message).imageSrc" 
                    [src]="sanitizeHtmlWithImageFix(SingleNotification.message).imageSrc" 
                    class="img-fluid rounded-2 shadow-sm my-3"
                    style="max-width: 100%; height: auto; object-fit: cover;" />
    </div>
  
  </div>
</p-dialog>